export default "__VITE_ASSET__UXPHkqpM__"